/*
 * @description:
 * @author: cuicui
 * @Date: 2022-11-29 20:26:41
 * @LastEditTime: 2023-01-30 00:02:11
 * @LastEditors: cuicui
 */
import { oauthRequestUrl, requestUrl } from "@/config/config";

// 店铺管理
export const shopList = `/sys/store`;
export const getShopById = (id) => `/sys/store/${id}`;
export const haltShopById = (id) => `/sys/store/${id}/halt-sale`; //整改
export const getShopStatisticsById = (id) => `/sys/store/${id}/Statistics`;
export const getShopAssetsById = (id) => `/sys/store-asset/store/${id}`;
export const auditShopById = (id) => `/sys/store/${id}/audit`; //post开店审核 get审核列表
export const reAuditShopById = (id) => `/sys/store/${id}/rectificationAudit`;
export const findCreatorByCreator = `/sys/store/creator`;
export const findUserStatisticsByCreator = `/sys/order/statistics`;
export const findUserStatisticsByCreator2 = `/manage/order/statistics`;
export const getStoreMembersList = `/sys/store-members`;

// 用户管理
// 需要从oauth平台获取
export const getUserList = `${oauthRequestUrl}/mall-admin/users`;
export const getUserBySubId = (userId) =>
  `${oauthRequestUrl}/mall-admin/audit/users/${userId}`;
export const getAuditListByUserId = (userId) =>
  `${oauthRequestUrl}/mall-admin/audit/users/${userId}/certifications`;
export const updateAuditByUserIdAndId = (userId, id) =>
  `${oauthRequestUrl}/mall-admin/audit/users/${userId}/certifications/${id}`;
export const getUserById = (id) => `${oauthRequestUrl}/mall-admin/users/${id}`;
export const enableUserById = (id) =>
  `${oauthRequestUrl}/mall-admin/users/${id}/enable`;
export const disableUserById = (id) =>
  `${oauthRequestUrl}/mall-admin/users/${id}/disable`;
export const syncUserInfoById = `${requestUrl}/sys/syn/user-infos`;
export const changeMobileById = (id) =>
  `${oauthRequestUrl}/mall-admin/users/${id}/change-mobile`;

//意见反馈管理
export const getFeedbackList = `/sys/feed-backs`;
export const getFeedbackById = (id) => `/sys/feed-backs/${id}`;
export const handleFeedbackById = (id) => `/sys/feed-backs/${id}/handle`;

//投诉管理
//店铺
export const getStoreComplaintList = `/sys/store/complaints`;
export const getStoreComplaintById = (id) => `/sys/store/complaints/${id}`;
export const handleStoreComplaintById = (id) =>
  `/sys/store/complaints/${id}/handle`;
export const toHandleStoreComplaintById = (id) =>
  `/sys/store/complaints/${id}/to-handle`;
export const handledStoreComplaintById = (id) =>
  `/sys/store/complaints/${id}/handle/result`;
export const rejectStoreComplaintById = (id) =>
  `/sys/store/complaints/${id}/reject`;
export const openBatchUpload = (id) => `/sys/store/${id}/open-batch-upload`;
export const closeBatchUpload = (id) => `/sys/store/${id}/close-batch-upload`;
//商品
export const getSpuComplaintList = `/sys/spu/complaints`;
export const getSpuComplaintById = (id) => `/sys/spu/complaints/${id}`;
export const handleSpuComplaintById = (id) =>
  `/sys/spu/complaints/${id}/handle/feedback-result`;

//提现管理
export const getWithdrawList = `/sys/withdrawal`;
export const getWithdrawById = (id) => `/sys/withdrawal/${id}`;
export const passWithdrawById = (id) => `/sys/withdrawal/approved/${id}`;
export const failWithdrawById = (id) => `/sys/withdrawal/rejection/${id}`;
export const withdrawSuccById = (id) => `/sys/withdrawal/transferred/${id}`;
export const withdrawFailById = (id) => `/sys/withdrawal/transfer-failed/${id}`;

// 普通版权登记管理
export const ptbqdjPage = `/copyright/normalregistration/syslist`;
export const ptbqdjUpdate = `/copyright/normalregistration/updateStatusAndFeedBack`;
// 数字版权登记管理
export const szbqdjPage = `/copyright/registration/syslist`;
export const registrationAudit = `/copyright/registration/audit`;
// 工作站查询
export const workPlaceUrl = "/copyright/registration/getAllWorkPlace";
// 版权维权
export const bqwqPage = `/protectright/syslist`;
export const bqwqUpdate = `/protectright/updateStatusAndFeedBack`;

// 发票
export const billPage = `/payInvoice/syslist`;
export const billUpdate = `/payInvoice/updateStatus`;
//收益管理
export const getPorfitList = `/sys/order-profit`;
export const getPlatformAsset = `/sys/platform-asset`;

// 作品分类
export const getAllWorkCategory = "/copyright/registration/getAllWorkCategory";

// 登记来源
export const getAllRegisterSource =
  "/manage/externalSystem/list?pageSize=-1&pageOn=1";
